import React from 'react';
import Modal from "../ui/components/modals/modal";
import './modal-declarations.css';

function ModalDeclarations({
                               showModal,
                               hideModal
                           }) {

    return (
        <Modal
            className="ModalDecBody"
            onClose={() => {
                hideModal();
            }}
            isOpen={showModal}>
            <div className="ModalDecTitle">
                Declarations
            </div>
            <div className="ModalDecContent">
                <div>
                    <ul>
                        <li>The type of insurance proposed has not been declined, cancelled, refused renewal or subject to any special terms by any other insurance company.</li>
                        <li>The type of insurance proposed has not had more than 4 claims in the last 3 years.</li>
                        <li>Reasonable precautions have been taken to prevent and mitigate any potential losses for the business.</li>
                        <li>The user has been properly authorised to generate a quotation on behalf of the business.</li>
                    </ul>
                </div>
            </div>
        </Modal>
    );
}


export default ModalDeclarations;
